import styled from '@emotion/styled';
import theme from '@ep/theme';
import React from 'react';
import HamburgerIcon from './hamburger.svg';

export interface HamburgerButtonProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  open: boolean;
}

const StyledButton = styled.button`
  border: none;
  background-color: transparent;
  padding: 1rem;
  cursor: pointer;
  order: 2;

  :focus {
    outline: 0;
  }
`;

interface HamburgerIconProps {
  open: boolean;
}

const StyledHamburgerIcon = styled(HamburgerIcon)<HamburgerIconProps>`
  path {
    transition: ${theme.transitions.create(['transform'])};
    transform-origin: 50% 50%;

    ${({ open }) =>
      open
        ? `
          :first-of-type {
            transform: rotate(405deg) translate(0, 6.5px);
          }

          :nth-of-type(2) {
            transform: rotate(405deg);
          }

          :nth-of-type(3) {
            transform: rotate(315deg) translate(0, -6.5px);
          }
          `
        : ''}
  }
`;

function Hamburger({ open, ...rest }: HamburgerButtonProps) {
  return (
    <StyledButton aria-label="Menu" {...rest}>
      <StyledHamburgerIcon open={open} />
    </StyledButton>
  );
}

export default Hamburger;
